
import React from 'react';
const Filter = (props: React.SVGProps<SVGSVGElement>) =>
(
    <svg
        width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path d="M8,11v1.12a.5.5,0,0,0,.15.35l7.28,7.36a.5.5,0,0,1,.15.35v6.89a.5.5,0,0,0,.28.45l3.95,1.41a.5.5,0,0,0,.72-.45l0-8.39a.54.54,0,0,1,.18-.35l7.12-7.25a.5.5,0,0,0,.15-.35V11Z"
            fill="currentColor">

        </path>

    </svg>
);


export default Filter;